const inrFmt = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const pctFmt = new Intl.NumberFormat("en-IN", {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const dateFmt = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
});

/** Format number as ₹ with lakh/crore grouping, e.g. ₹12,34,567.89 */
export function formatINR(value: number): string {
  return inrFmt.format(value);
}

/** Format as percentage string, e.g. 12.34% */
export function formatPct(value: number): string {
  return pctFmt.format(value / 100);
}

/** Format Date/ISO string to IST display string */
export function formatDateTime(value: string | Date): string {
  const d = typeof value === "string" ? new Date(value) : value;
  return dateFmt.format(d);
}

/** Format number with en-IN grouping (no currency symbol) */
export function formatNum(value: number): string {
  return new Intl.NumberFormat("en-IN").format(value);
}
